module.exports = __webpack_public_path__ + "static/src/content/images/processed/400/Band-Of-Brothers-S1.4125133.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/400/Band-Of-Brothers-S1.jpg
// module id = ZXpP
// module chunks = 0